import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';

import Menu, { MenuItem } from 'material-ui/Menu';
import { ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';

import VertIcon from '@material-ui/icons/MoreVert';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import EyeIcon from '@material-ui/icons/Visibility';
import PencilIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import RepeatIcon from '@material-ui/icons/Autorenew';
import CopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';

import * as Utils from '../../../lib/designerUtils';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as ToastState from '../../../state/reducer/clipboard/toast';
import * as DesignerState from '../../../state/reducer/designer/designer';
import WORKOUT_ACTIONS from '../../../state/reducer/workout/actionsCalendar';
import { TYPES as PROGRAM_TYPES } from '../../../state/reducer/calendar/programTypes';

import Editable from '../../designer/components/Editable';

import Console from '../../../lib/debug';

class SessionHeader extends Component {
    state = {
        anchorEl: null
    };

    getMenuItems() {
        let list = [];
        let session = this.props.session;
        let isSubscription = Utils.isSubscription(
            this.props.session,
            this.props.programType
        );
        let isProgram = this.props.programType === PROGRAM_TYPES.FIXED;
        let publishText = session.published === 1 ? 'Unpublish' : 'Publish';
        let publishIcon = session.published === 1 ? <StopIcon /> : <PlayIcon />;

        if (!isProgram) {
            list.push(
                <MenuItem
                    key="m1"
                    disabled={isSubscription}
                    onClick={event =>
                        this.handleMenuItemClick(event, WORKOUT_ACTIONS.PUBLISH)
                    }
                >
                    <ListItemIcon>{publishIcon}</ListItemIcon>
                    <ListItemText inset primary={publishText} />
                </MenuItem>
            );
        }

        list.push(
            <MenuItem
                key="m2"
                onClick={event =>
                    this.handleMenuItemClick(event, WORKOUT_ACTIONS.PREVIEW)
                }
            >
                <ListItemIcon>
                    <EyeIcon />
                </ListItemIcon>
                <ListItemText inset primary="Preview" />
            </MenuItem>
        );

        list.push(<Divider key="d1" />);

        if (isSubscription) {
            list.push(
                <MenuItem
                    key="m4"
                    onClick={event =>
                        this.handleMenuItemClick(
                            event,
                            WORKOUT_ACTIONS.COPY_AND_EDIT
                        )
                    }
                >
                    <ListItemIcon>
                        <PencilIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Copy and Edit" />
                </MenuItem>
            );
        } else {
            list.push(
                <MenuItem
                    key="m4"
                    onClick={event =>
                        this.handleMenuItemClick(event, WORKOUT_ACTIONS.EDIT)
                    }
                >
                    <ListItemIcon>
                        <PencilIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Edit" />
                </MenuItem>
            );
        }

        list.push(
            <MenuItem
                key="m5"
                disabled={isSubscription}
                onClick={event =>
                    this.handleMenuItemClick(event, WORKOUT_ACTIONS.SAVE)
                }
            >
                <ListItemIcon>
                    <SaveIcon />
                </ListItemIcon>
                <ListItemText inset primary="Save to Library as..." />
            </MenuItem>
        );

        list.push(<Divider key="d2" />);
        list.push(
            <MenuItem
                key="m6"
                onClick={event =>
                    this.handleMenuItemClick(event, WORKOUT_ACTIONS.REPEAT)
                }
            >
                <ListItemIcon>
                    <RepeatIcon />
                </ListItemIcon>
                <ListItemText inset primary="Repeat" />
            </MenuItem>
        );

        list.push(
            <MenuItem
                key="m7"
                onClick={event =>
                    this.handleMenuItemClick(event, WORKOUT_ACTIONS.COPY)
                }
            >
                <ListItemIcon>
                    <CopyIcon />
                </ListItemIcon>
                <ListItemText inset primary="Copy" />
            </MenuItem>
        );

        list.push(
            <MenuItem
                key="m8"
                onClick={event =>
                    this.handleMenuItemClick(event, WORKOUT_ACTIONS.DELETE)
                }
            >
                <ListItemIcon>
                    <DeleteIcon />
                </ListItemIcon>
                <ListItemText inset primary="Delete" />
            </MenuItem>
        );

        return list;
    }

    onTitleBlur(title) {
        let session = this.props.session;
        let dispatch = this.props.dispatch;
        if (title !== session.title) {
            DesignerState.updateSession(dispatch, session, 'title', title);
        }
    }

    openEditMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMenuItemClick = (event, action) => {
        this.setState({ anchorEl: null });
        let date = moment(this.props.session.date);
        let dayKey = Utils.getDayKey(date);
        CalendarState.performSessionAction(dayKey, this.props.session, action);
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    showWarningToast = () => {
        let session = this.props.session || this.props.sessionUpdated;
        let isSubscription =
            session.program_type === 1 &&
            CalendarState.getProgramType() !== PROGRAM_TYPES.CALENDAR;
        if (!(session.published || isSubscription)) return;

        let message = isSubscription
            ? 'Sorry, cannot move or update subscriptions'
            : 'You must unpublish to move or update this session';

        return ToastState.showWarningMessage(message);
    };

    render() {
        Console.render('SessionHeader');
        const { anchorEl } = this.state;

        let session = this.props.session || this.props.sessionUpdated;

        if (session.fake) {
            return null;
        }

        let logo = null;
        if (session.logo || session.icon) {
            logo = (
                <div className="session-logo">
                    <img alt="" src={session.logo || session.icon} />
                </div>
            );
        }

        let titleStatus = null;
        if (
            session.setKeys &&
            CalendarState.getProgramType() !== 2 &&
            this.props.session.session !== 'null'
        ) {
            titleStatus = <div className="title-status" />;
        }

        let infoClasses =
            window.location.href.indexOf('oneonone') > 0
                ? 'item-title-area  summary-athlete'
                : 'item-title-area';
        let editSessionControls = !this.props.isPreview ? (
            <div className="edit-session">
                <VertIcon onClick={ev => this.openEditMenu(ev)} />
                <Menu
                    className="th-menu"
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    ref={this.sessionRef}
                >
                    {this.getMenuItems()}
                </Menu>
            </div>
        ) : null;

        let sessionHeader;

        if (
            session.published === 1 ||
            (session.program_type === 1 &&
                CalendarState.getProgramType() !== PROGRAM_TYPES.CALENDAR)
        ) {
            sessionHeader = (
                <div className={infoClasses}>
                    <div className="session-info">
                        <div className="title">
                            {logo}
                            <span
                                onMouseDown={this.showWarningToast}
                                className="program-title"
                            >
                                {session.title}
                            </span>
                            {editSessionControls}
                        </div>
                        {titleStatus}
                    </div>
                </div>
            );
        } else {
            sessionHeader = (
                <div className={infoClasses}>
                    <div className="session-info">
                        <div className="title">
                            {logo}
                            <Editable
                                value={session.title}
                                preventEdit={this.props.isPreview}
                                onValueChanged={this.onTitleBlur.bind(this)}
                                className="program-title"
                            />
                            {editSessionControls}
                        </div>
                        {titleStatus}
                    </div>
                </div>
            );
        }

        let body = <div className="session-preview">{sessionHeader}</div>;

        let classes = 'calendar-item-session r-calendar-session session-header';
        if (this.props.sessionSelected) {
            classes += ' selected-header';
        }

        return (
            <div className={classes} id={session.workout_id}>
                {body}
            </div>
        );
    }
}

const mapSessionStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        contextType: state.calendar.infoTree.team.type,
        designerUrl: state.calendar.uiTree.designerUrl,
        isPubEnabled: state.calendar.infoTree.team.pub_enabled === 1,
        pubDays: state.calendar.infoTree.team.pub_days,
        pubTime: state.calendar.infoTree.team.pub_time,
        programType: state.calendar.infoTree.programType
    };
};

export default connect(mapSessionStateToProps)(SessionHeader);



// WEBPACK FOOTER //
// ./src/view/calendar/components/SessionHeader.jsx